import { useQuery } from '@tanstack/react-query';

import type { SEOLanding } from 'app/typings/SEOLanding';
import { apiRequest } from 'app/utils/request/api';

export const path = '/landing:slug' as const;

export function useSEOLanding(slug: string) {
  const { data, isFetching } = useQuery<SEOLanding>({
    queryKey: ['seoLanding', slug],
    queryFn: () =>
      apiRequest({
        path,
        params: { slug },
      }),
    staleTime: 0,
  });

  return {
    data,
    isFetching,
  };
}
